"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));

var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var utils_1 = require("../../../utils");

var Base_1 = __importDefault(require("../Base"));

var useStyles_1 = __importDefault(require("./useStyles"));

var constants_1 = require("../../../constants");
/**
* General Moment for integrating a sidebar `Drawer` component with a Moment.
*/


var SideBarMoment = function SideBarMoment(props) {
  var children = props.children,
      onClose = props.onClose,
      sidebar = props.sidebar,
      sideBarClassName = props.sideBarClassName,
      sideBarContent = props.sideBarContent;
  var classes = (0, useStyles_1.default)();
  var drawerPaperClasses = (0, utils_1.classList)(classes.sideBar, sideBarClassName || '');
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(Base_1.default, __assign({}, props), react_1.default.createElement(CssBaseline_1.default, null), react_1.default.createElement("main", null, children), react_1.default.createElement(Drawer_1.default, {
      anchor: "right",
      open: sidebar,
      onClose: onClose,
      classes: {
        paper: drawerPaperClasses
      }
    }, sideBarContent))
  );
};

SideBarMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Determines if the `Drawer` is visible. */
  sidebar: prop_types_1.default.bool.isRequired,

  /** Class name for the `SideBar` `Drawer` root. */
  sideBarClassName: prop_types_1.default.string,

  /** Determines the content in the `Drawer` body of the `Moment`. */
  sideBarContent: prop_types_1.default.node,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
SideBarMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.SideBar,
  sidebar: false,
  type: constants_1.MomentType.SideBar
});
exports.default = SideBarMoment;